import * as rd from '@devexperts/remote-data-ts'
import { isKioskSelector } from '@/store/appSlice'
import { availableFeaturedServicesSelector } from '@/store/cartSlice/selectors/selectAvailableFeaturedServices.ts'
import { extraSlice, selectIsExtraStepVisible } from '@/store/extraSlice'
import { useAppSelector } from './store'

export const useIsExtraStepNecessary = () => {
  const isExtraStepVisible = useAppSelector(selectIsExtraStepVisible)
  const weatherInsurancePrice = useAppSelector(
    extraSlice.selectors.weatherInsurancePricePreview
  )
  const availableFeaturedServices = useAppSelector(
    availableFeaturedServicesSelector
  )
  const isKiosk = useAppSelector(isKioskSelector)

  const isWeatherInsuranceAvailable =
    rd.isSuccess(weatherInsurancePrice) && weatherInsurancePrice.value >= 1

  const extraStepHasAvailableServices =
    availableFeaturedServices && availableFeaturedServices?.length >= 1

  // Here we check for three conditions:
  // 1: the presence of featured services compatible with the spots added to cart by the user
  // 2 and 3: presence of weather-insurance for that period (if the app is in Kiosk mode we must ignore any insurance)
  const extraStepHasVisibleContent =
    extraStepHasAvailableServices || (!isKiosk && isWeatherInsuranceAvailable)

  return isExtraStepVisible && extraStepHasVisibleContent
}
